import React, { useContext } from 'react';
import { AuthContext } from '../../context/AuthProvider';
import { CommonPageProps } from '../../App.types';
import { WelcomeModal } from '../../components/WelcomeModal/WelcomeModal';
import './WelcomePage.scss';

export const WelcomePage: React.FC<CommonPageProps> = () => {
  const { handleAfterLogin, loggedUser } = useContext(AuthContext);

  !loggedUser?.forcePasswordChange && handleAfterLogin(true, loggedUser?.id);

  return (
    <WelcomeModal
      passwordChange={loggedUser?.lastCredentialType === 'email'}
      email={loggedUser?.email}
      id={loggedUser?.id}
    />
  );
};
